"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearButton = void 0;

var tslib_1 = require("tslib");

var ui_butticon_1 = require("@hopin-team/ui-butticon");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var SizeRight;

(function (SizeRight) {
  SizeRight["small"] = "2rem";
  SizeRight["medium"] = "2.5rem";
})(SizeRight || (SizeRight = {}));

var SizeTop;

(function (SizeTop) {
  SizeTop["small"] = "0.25rem";
  SizeTop["medium"] = "0.5rem";
})(SizeTop || (SizeTop = {}));

exports.ClearButton = (0, styled_components_1.default)(ui_butticon_1.Butticon).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['sizeOption'].includes(prop);
  }
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  right: ", ";\n  top: ", ";\n  color: ", ";\n\n  &:disabled,\n  &:disabled:hover {\n    color: ", ";\n    background-color: transparent;\n  }\n\n  &:hover {\n    color: ", ";\n    background-color: transparent;\n  }\n\n  &:focus {\n    position: absolute;\n  }\n\n  &:focus-visible {\n    position: absolute;\n  }\n"], ["\n  position: absolute;\n  right: ", ";\n  top: ", ";\n  color: ", ";\n\n  &:disabled,\n  &:disabled:hover {\n    color: ", ";\n    background-color: transparent;\n  }\n\n  &:hover {\n    color: ", ";\n    background-color: transparent;\n  }\n\n  &:focus {\n    position: absolute;\n  }\n\n  &:focus-visible {\n    position: absolute;\n  }\n"])), function (_a) {
  var _b = _a.sizeOption,
      sizeOption = _b === void 0 ? 'small' : _b;
  return SizeRight[sizeOption];
}, function (_a) {
  var _b = _a.sizeOption,
      sizeOption = _b === void 0 ? 'small' : _b;
  return SizeTop[sizeOption];
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["500"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["400"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["500"]', theme);
});
var templateObject_1;